jQuery(document).ready(function($){
	var winWidth = $(window).width();
	$('.expand-menu-item').on('click', function(){
		var winWidth = $(window).width();
		var type =	$(this).data('type');
		if(winWidth > 991) {

			if($(this).hasClass('ExpandMenuOpen')){
				$(this).removeClass('ExpandMenuOpen');
			} else {
				$('.expand-menu-item').removeClass('ExpandMenuOpen');
				$(this).addClass('ExpandMenuOpen');
			}
			if ( $('.expandMenuWrp[data-type='+type+']').hasClass( "visible" ) ) {
				$('.expandMenuWrp').removeClass('visible');
			} else {
				$('.expandMenuWrp').removeClass('visible');
				$('.expandMenuWrp[data-type='+type+']').addClass('visible');
			}
		} else {
			if ( $('.expand-sub-menu[data-type='+type+']').hasClass( "visible" ) ) {
				$('.expand-sub-menu').slideUp();
				$('.expand-sub-menu').removeClass('visible');
			} else {

				$('.expand-sub-menu').slideUp();
				$('.expand-sub-menu[data-type='+type+']').slideDown();
				$('.expand-sub-menu').removeClass('visible');
				$('.expand-sub-menu[data-type='+type+']').addClass('visible');
			}
		}
	});
	if(winWidth > 991) {
		// $('.expand-menu-item').on('mouseenter', function(){
		// 	var type =	$(this).data('type');
		// 	console.log(type);
		// 	$('.expandMenuWrp[data-type='+type+']').addClass('peak');
		// });
		//
		// $('.expand-menu-item').on('mouseleave', function(){
		// 	var type =	$(this).data('type');
		// 	console.log(type);
		// 	$('.expandMenuWrp[data-type='+type+']').removeClass('peak');
		// });
	}

	$('.closeExpandMenu').on('click', function(){
		$('.expandMenuWrp').removeClass('visible');
	});


});
